import { render } from "./theme8.vue?vue&type=template&id=d4c4be72&scoped=true"
import script from "./theme8.vue?vue&type=script&lang=js"
export * from "./theme8.vue?vue&type=script&lang=js"

import "./theme8.vue?vue&type=style&index=0&id=d4c4be72&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d4c4be72"

export default script